// material-ui
import { Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => (
    <Stack direction="row" justifyContent="flex-end">
        <Typography variant="subtitle2" component="a" href="https://www.styrk.io/" target="_blank">
            Styrk
        </Typography>
    </Stack>
);

export default AuthFooter;
